type ApplyWaitingUpdateDeps = {
  getRegistration: () => Promise<
    Pick<ServiceWorkerRegistration, "waiting"> | undefined
  >;
  activateWaitingWorker: () => Promise<void>;
  reload: () => void;
};

/**
 * Activates the waiting service worker; the tab then reloads when it takes
 * control. With none waiting — another tab already activated it — a plain
 * reload is all this tab needs to load the new build.
 */
export const applyWaitingUpdate = async ({
  getRegistration,
  activateWaitingWorker,
  reload,
}: ApplyWaitingUpdateDeps): Promise<void> => {
  const registration = await getRegistration();
  if (!registration?.waiting) {
    reload();
    return;
  }
  await activateWaitingWorker();
};
